import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ModalPersonalData = ({ open, handelClose, personalData }) => {
    const { t } = useTranslation();

    return (
        <Modal
            width={600}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <div className="text-2xl font-semibold">
                    {t('dataFlow.personalData')}
                </div>
            </div>

            <div className="text-xs font-semibold text-gray-PHX pb-2">
                {t('TotalItems', { length: personalData?.length })}
            </div>

            <div className="grid grid-cols-2 overflow-auto max-h-[34vh]">
                {personalData?.map((item, i) => (
                    <div className="col-span-1 box-content my-1 mx-1">
                        <div className="grid grid-cols-4 flex items-center p-2">
                            <div className="col-span-1">
                                <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 40 40"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <rect
                                        width="40"
                                        height="40"
                                        rx="20"
                                        fill="#DFF3FC"
                                    />
                                    <g clipPath="url(#clip0_7772_395389)">
                                        <path
                                            d="M20.0016 20.347C22.573 20.347 24.675 18.2449 24.675 15.6735C24.675 13.102 22.573 11 20.0016 11C17.4301 11 15.3281 13.102 15.3281 15.6735C15.3281 18.2449 17.4302 20.347 20.0016 20.347Z"
                                            fill="#1890FF"
                                        />
                                        <path
                                            d="M28.0211 24.082C27.8986 23.7759 27.7354 23.4902 27.5517 23.2249C26.6129 21.8371 25.164 20.9187 23.5313 20.6942C23.3273 20.6738 23.1028 20.7146 22.9395 20.8371C22.0824 21.4697 21.062 21.7963 20.0007 21.7963C18.9395 21.7963 17.9191 21.4697 17.0619 20.8371C16.8986 20.7146 16.6742 20.6534 16.4701 20.6942C14.8374 20.9187 13.3681 21.8371 12.4497 23.2249C12.266 23.4902 12.1027 23.7963 11.9803 24.082C11.9191 24.2045 11.9395 24.3473 12.0007 24.4698C12.164 24.7555 12.3681 25.0412 12.5517 25.2861C12.8374 25.6739 13.1436 26.0208 13.4905 26.3473C13.7762 26.633 14.1027 26.8983 14.4293 27.1637C16.0415 28.3678 17.9803 29.0004 19.9803 29.0004C21.9803 29.0004 23.9191 28.3677 25.5313 27.1637C25.8579 26.9188 26.1844 26.633 26.4701 26.3473C26.7967 26.0208 27.1232 25.6738 27.4089 25.2861C27.613 25.0208 27.7967 24.7555 27.9599 24.4698C28.0619 24.3473 28.0823 24.2044 28.0211 24.082Z"
                                            fill="#1890FF"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_7772_395389">
                                            <rect
                                                width="18"
                                                height="18"
                                                fill="white"
                                                transform="translate(11 11)"
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div className="col-span-3 font-semibold">
                                {item.name}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
};
export default ModalPersonalData;
